/**
 * @file CrownIcon.tsx
 * @description A React component that renders an SVG crown icon.
 * The icon's color can be customized via the `className` prop.
 */

import React from "react";
import { IconProps } from "../../../types";

const CrownIcon: React.FC<IconProps> = ({ className = "" }) => (
  <svg
    width="15"
    height="14"
    viewBox="0 0 15 14"
    preserveAspectRatio="xMidYMid meet"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <circle cx="7.26953" cy="7" r="7" fill="#37D399" />
    <path
      d="M7.5601 4.92616C7.71767 4.8294 7.82272 4.65386 7.82272 4.4562C7.82272 4.15074 7.5753 3.90332 7.26983 3.90332C6.96436 3.90332 6.71695 4.15074 6.71695 4.4562C6.71695 4.65524 6.82199 4.8294 6.97957 4.92616L6.18756 6.51017C6.06178 6.76173 5.73558 6.83361 5.5158 6.65807L4.28425 5.67255C4.35337 5.57994 4.39483 5.46522 4.39483 5.34082C4.39483 5.03535 4.14742 4.78794 3.84195 4.78794C3.53648 4.78794 3.28906 5.03535 3.28906 5.34082C3.28906 5.64629 3.53648 5.89371 3.84195 5.89371H3.85162L4.48329 9.36859C4.55931 9.78878 4.9256 10.0956 5.35409 10.0956H9.18558C9.61268 10.0956 9.97896 9.79016 10.0564 9.36859L10.688 5.89371H10.6977C11.0032 5.89371 11.2506 5.64629 11.2506 5.34082C11.2506 5.03535 11.0032 4.78794 10.6977 4.78794C10.3922 4.78794 10.1448 5.03535 10.1448 5.34082C10.1448 5.46522 10.1863 5.57994 10.2554 5.67255L9.02386 6.65807C8.80409 6.83361 8.47788 6.76173 8.3521 6.51017L7.5601 4.92616Z"
      fill="#0D47A1"
    />
  </svg>
);

export default CrownIcon;
